import { type ReactNode, type FC, memo } from 'react';
import { twMerge } from 'tailwind-merge';
import { Text } from 'Text';

type Props = {
    header: string;
    children: ReactNode;
    className?: string;
};

export const ContentItemBoxListContainer: FC<Props> = memo(({ header, children, className }) => (
    <div>
        <Text as="h2" weight="semibold" color="black" uppercase className="px-3 pb-5">
            {header}
        </Text>

        <div className={twMerge('flex flex-col gap-y-1.5 md:grid md:grid-cols-2 md:gap-x-5 md:gap-y-2.5', className)}>
            {children}
        </div>
    </div>
));
